export const METRIC_LABELS = {
  exit_velocity: "Exit Velocity",
  average_exit_velocity: "Avg Exit Velocity",
  bat_speed: "Bat Speed",
  ten_yard_sprint: "10-Yard Sprint",
  thirty_yard_sprint: "30-Yard Sprint",
  sixty_yard_sprint: "60-Yard Sprint",
  five_ten_five_shuttle: "5-10-5 Shuttle",
  infield_velocity: "Infield Velocity",
  outfield_velocity: "Outfield Velocity",
  pop_time: "Pop Time",
  catcher_velocity: "Catcher Velocity",
  fastball_velocity: "Fastball Velocity",
  spin_rate: "Spin Rate",
  strike_percentage: "Strike %",
  pitch_movement: "Pitch Movement",
};

export const METRIC_UNITS = {
  exit_velocity: "mph", average_exit_velocity: "mph", bat_speed: "mph",
  ten_yard_sprint: "s", thirty_yard_sprint: "s", sixty_yard_sprint: "s", five_ten_five_shuttle: "s",
  infield_velocity: "mph", outfield_velocity: "mph", pop_time: "s", catcher_velocity: "mph",
  fastball_velocity: "mph", spin_rate: "rpm", strike_percentage: "%", pitch_movement: "in",
};

export const ALL_METRICS = Object.keys(METRIC_LABELS);
